export enum NotificationItemType {
  rock = 'rock',
  milestone = 'milestone',
  todo = 'todo',
  shortTermIssue = 'shortTermIssue',
  longTermIssue = 'longTermIssue',
  headline = 'headline',
  cascadingMessage = 'cascadingMessage',
}
